export default __webpack_public_path__ + "static/media/loading.d8cba43d.svg";